import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchProducts } from '../api/fetchProducts';
import Loader from '../components/Loader';
import NieZnaleziono from './NieZnaleziono';
import useDocumentTitle from '../hooks/useDocumentTitle';

/**
 * Strona „Jaki wallbox do [auto]” albo strona zbiorcza (/dobor-ladowarki/<slug>).
 *
 * Treść składa backend (`backend_api/seo_auta.py`) z bazy ładowarek pokładowych i katalogu
 * wallboxów: ten sam fragment HTML dostaje bot w pierwszym HTML-u i użytkownik tutaj, więc
 * teksty się nie rozjadą. Fragment jest generowany u nas z naszych danych (z escapowaniem),
 * dlatego wstawiamy go jako HTML. Linki wewnętrzne obsługujemy routerem, bez przeładowania.
 */
const KLASY_TRESCI = `text-gray-700
  [&_nav]:mb-4 [&_nav]:text-sm [&_nav]:text-gray-500 [&_nav_a]:text-blue-600
  [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:text-gray-900 [&_h1]:mb-3
  [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-gray-900
  [&_h3]:mt-4 [&_h3]:font-semibold [&_h3]:text-gray-900
  [&_p]:mt-2 [&_p]:leading-relaxed
  [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-6
  [&_a]:text-blue-600 hover:[&_a]:underline
  [&_table]:mt-3 [&_table]:w-full [&_table]:text-sm [&_table]:border-collapse
  [&_th]:border-b [&_th]:border-gray-200 [&_th]:py-2 [&_th]:pr-3 [&_th]:text-left [&_th]:font-semibold
  [&_td]:border-b [&_td]:border-gray-100 [&_td]:py-2 [&_td]:pr-3`;

const StronaAuta = () => {
  const { strona } = useParams();
  const navigate = useNavigate();
  const [dane, setDane] = useState(null);
  const [brak, setBrak] = useState(false);

  useDocumentTitle(dane?.title || 'Jaki wallbox do auta');

  useEffect(() => {
    let anulowane = false;
    setDane(null);
    setBrak(false);
    fetchProducts(`strona_auta/${encodeURIComponent(strona)}`)
      .then((d) => { if (!anulowane) setDane(d); })
      .catch(() => { if (!anulowane) setBrak(true); });
    return () => { anulowane = true; };
  }, [strona]);

  // Linki wewnętrzne z fragmentu HTML przez router (bez przeładowania strony).
  const klik = (e) => {
    const a = e.target.closest('a');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.startsWith('/') && !e.metaKey && !e.ctrlKey && !e.shiftKey && a.target !== '_blank') {
      e.preventDefault();
      navigate(href);
    }
  };

  if (brak) return <NieZnaleziono />;
  if (!dane) return <Loader />;

  return (
    <div className="mx-auto mb-16 mt-8 max-w-4xl px-4 md:px-8">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <article className={KLASY_TRESCI} onClick={klik} dangerouslySetInnerHTML={{ __html: dane.html }} />
    </div>
  );
};

export default StronaAuta;
